import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import HourRank from '@hooks/web/public/hourRank.tsx';
import GroupRank from '@hooks/web/public/groupRank.tsx';
import RichRank from '@hooks/web/public/richRank.tsx';
const { useContext } = React;
const Nto3: React.FC = () => {
  const { iStage } = useContext(StageDefault);
  return (
    <div
      className='nto3'
    >
      <HourRank iStage={iStage > 3 ? 3 : iStage} />
      <GroupRank iStage={iStage > 3 ? 3 : iStage} from={1} iRevive={0} />
      <RichRank />
    </div>
  )
}

export default Nto3;